export const ACCEPTED_DOCUMENT_TYPES = [
  '.pdf',
  '.doc',
  '.docx',
  '.jpg',
  '.jpeg',
  '.png',
];

export const MAX_DOCUMENT_SIZE_MB = 10;
export const MAX_DOCUMENT_SIZE_BYTES = MAX_DOCUMENT_SIZE_MB * 1024 * 1024;

export const ACCEPTED_DOCUMENT_TYPES_LABEL = 'PDF, DOC, DOCX, JPG or PNG';

export const ACCEPTED_IMAGE_TYPES = ['image/*'];

export const ACCEPTED_DOCUMENT_TYPES_INPUT = [
  ...ACCEPTED_DOCUMENT_TYPES,
  ...ACCEPTED_IMAGE_TYPES,
].join(',');

export const formatFileSize = (bytes: number): string => {
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${Math.round(bytes / 1024)}kb`;
  return `${(bytes / (1024 * 1024)).toFixed(1)}mb`;
};

export const isAcceptedDocumentType = (filename: string): boolean => {
  const ext = `.${filename.split('.').pop()?.toLowerCase()}`;
  return ACCEPTED_DOCUMENT_TYPES.indexOf(ext) !== -1;
};

export const isImageType = (contentType: string): boolean =>
  contentType.startsWith('image/');

export const isAudioType = (contentType: string): boolean =>
  contentType.startsWith('audio/');

const AUDIO_MIME_PREFERENCES = [
  'audio/webm;codecs=opus',
  'audio/webm',
  'audio/mp4',
  'audio/aac',
];

export const pickAudioMimeType = (): string => {
  for (const mime of AUDIO_MIME_PREFERENCES) {
    if (
      typeof MediaRecorder !== 'undefined' &&
      MediaRecorder.isTypeSupported(mime)
    )
      return mime;
  }
  return '';
};

/** The filename with its extension swapped for `ext`, or added if it has none. */
export const withExtension = (filename: string, ext: string): string =>
  `${filename.replace(/\.[^./]*$/, '')}.${ext}`;

export const extensionForAudioMime = (mime: string): string => {
  if (mime.includes('webm')) return 'webm';
  if (mime.includes('mp4')) return 'mp4';
  if (mime.includes('aac')) return 'aac';
  return 'audio';
};
